module.exports = {
      id: "social-instagram-usage",
      viewBox: "0 0 500 500",
      url: __webpack_public_path__ + "images/sprites__def--a862b1051269b7ffa37132446ced7b9f.svg#social-instagram-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__def/sprites/social-instagram.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__def/sprites/social-instagram.svg
// module chunks = site__def